import { render, staticRenderFns } from "./VideosPage.vue?vue&type=template&id=47c284d0&scoped=true"
import script from "./VideosPage.vue?vue&type=script&lang=js"
export * from "./VideosPage.vue?vue&type=script&lang=js"
import style0 from "./VideosPage.vue?vue&type=style&index=0&id=47c284d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c284d0",
  null
  
)

export default component.exports